import React from 'react';
import PropTypes from 'prop-types';
import { SemibigHeader, SmallHeader } from '@narvar/nth-header';
import Divider from '@narvar/nth-divider';
import Button, { primary } from '@narvar/nth-button';
import ReturnsCalendar from '../../../../react-components/ReturnsCalendar';

const SchedulePanel = ({
  ctaColor,
  showError,
  errorMessage,
  handleDaySelect,
  selectedPickupDate,
  pickupDates,
  pickupLocationLabel,
  pickupLocationSubtitle,
  pickupLocationDetails,
  datePickerLabel,
  datePickerSubtitle,
  buttonText,
  buttonDisabled,
  buttonOnClick,
}) => (
  <div>
    <SemibigHeader s={{ margin: '0 0 0.2rem 0' }}>{pickupLocationLabel}</SemibigHeader>
    <p style={{ marginBottom: '1rem' }}>{pickupLocationSubtitle}</p>
    {pickupLocationDetails.map((detail) => (
      <p style={{ margin: 0 }}>{detail}</p>
    ))}
    <SmallHeader s={{ margin: '1.25rem 0 0.2rem 0' }}>{datePickerLabel}</SmallHeader>
    <p>{datePickerSubtitle}</p>
    <Divider />
    <ReturnsCalendar
      style={{
        Weekday: {
          borderBottom: 'none',
        },
        DayNormalStyle: {
          color: ctaColor,
        },
        DaySelectedStyle: {
          color: ctaColor,
          borderColor: ctaColor,
          borderWidth: '0.125rem',
        },
      }}
      handleDaySelect={handleDaySelect}
      selectedDay={selectedPickupDate}
      include={pickupDates}
    />
    {showError && (
      <p
        style={{
          margin: '1rem 0',
          color: '#E53935',
        }}
      >
        {errorMessage}
      </p>
    )}
    <Button
      big
      onClick={buttonOnClick}
      disabled={buttonDisabled}
      s={primary({ disabled: buttonDisabled })}
      className="narvar-btn-primary"
    >
      {buttonText}
    </Button>
  </div>
);

SchedulePanel.defaultProps = {
  ctaColor: '#000000',
  showError: false,
  errorMessage: 'Service is unavailable for this location.',
  selectedPickupDate: null,
  pickupDates: [],
  pickupLocationLabel: 'Pickup Location',
  pickupLocationSubtitle: 'This is the original delivery address and cannot be edited.',
  pickupLocationDetails: [],
  datePickerLabel: 'Select a Date:',
  datePickerSubtitle: 'Pickups will take place between 10AM and 4PM local time.',
  buttonText: 'DONE',
  buttonDisabled: false,
  buttonOnClick: () => {},
};

SchedulePanel.propTypes = {
  ctaColor: PropTypes.string,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string,
  changePanel: PropTypes.func.isRequired,
  handleDaySelect: PropTypes.func.isRequired,
  selectedPickupDate: PropTypes.instanceOf(Date),
  pickupDates: PropTypes.arrayOf(PropTypes.string),
  pickupLocationLabel: PropTypes.string,
  pickupLocationSubtitle: PropTypes.string,
  pickupLocationDetails: PropTypes.arrayOf(PropTypes.string),
  datePickerLabel: PropTypes.string,
  datePickerSubtitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  buttonOnClick: PropTypes.func,
};

export default SchedulePanel;
